module.exports = __webpack_public_path__ + "img/logo-psi.782030f0.svg";